import { useCallback } from 'react';
export function useForkRef(...refs) {
    return useCallback((v) => refs.forEach((ref) => {
        if (typeof ref === 'function') {
            ref(v);
        }
        else if (ref != null) {
            ref.current = v;
        }
    }), refs);
}
//# sourceMappingURL=useForkRef.js.map